import Box from "@mui/material/Box";
import { useRef } from "react";

import {
  TRUSTPILOT_BUSINESS_UNIT,
  TRUSTPILOT_MICRO_COMBO,
  TRUSTPILOT_REVIEWS_US,
  useTrustpilotWidget,
} from "./trustpilot";

/**
 * `main_header_trust_wrap`: a hero's star row, on a pill 38px tall. It shares
 * `header_left_top_content` with the breadcrumb, which sets the two 12 apart;
 * the column's own gap runs under the pair.
 */
export default function HeroTrustpilot() {
  const host = useRef<HTMLDivElement>(null);
  useTrustpilotWidget(host);

  return (
    <Box
      sx={{
        p: "8px",
        borderRadius: "8px",
        border: "1px solid rgba(26, 179, 148, 0.1)",
        backgroundColor: "rgba(26, 179, 148, 0.1)",
        alignSelf: "flex-start",
        width: 1,
      }}
    >
      <Box
        ref={host}
        className="trustpilot-widget"
        sx={{ position: "relative", height: "20px" }}
        data-locale="en-US"
        data-template-id={TRUSTPILOT_MICRO_COMBO}
        data-businessunit-id={TRUSTPILOT_BUSINESS_UNIT}
        data-style-height="20"
        data-style-width="100%"
        data-theme="light"
      >
        {/* The published widget's own fallback, which the bootstrap replaces with its iframe. */}
        <a href={TRUSTPILOT_REVIEWS_US} target="_blank" rel="noopener">
          Trustpilot
        </a>
      </Box>
    </Box>
  );
}
